import { CONFIG } from "@/lib/config.ts";
import Keycloak from "keycloak-js";
import { logError } from "@/sentry.ts";

const { AUTH_URL, AUTH_REALM, AUTH_CLIENT_ID } = CONFIG;

export const keycloak = new Keycloak({
  url: AUTH_URL,
  realm: AUTH_REALM,
  clientId: AUTH_CLIENT_ID,
});

export async function keycloakInit() {
  try {
    await keycloak.init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
    });
  } catch (error) {
    logError(error);
  }
}
